import { render, staticRenderFns } from "./CourseChairs.vue?vue&type=template&id=274d0a52&scoped=true&"
import script from "./CourseChairs.vue?vue&type=script&lang=js&"
export * from "./CourseChairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d0a52",
  null
  
)

export default component.exports